export const DEVICE_TREE_DND_MIME = "application/x-orion-device-dnd";
export const DEVICE_PLACEMENT_POINTER_DROP_EVENT = "orion-device-placement-pointer-drop";
export const DEVICE_PLACEMENT_SAVE_EVENT = "orion-device-placement-save";
export const DEVICE_PLACEMENT_CANCEL_EVENT = "orion-device-placement-cancel";
const PLACEABLE_DEVICE_ENTITY_TYPES = ["device", "camera", "compositeDevice"];

let currentDeviceDragPayload = null;

export const isPlaceableDeviceEntity = entity => {
	const entityType = entity?.entityType || entity?.type;

	if (!entity?.id || entity.id === "root" || !PLACEABLE_DEVICE_ENTITY_TYPES.includes(entityType)) {
		return false;
	}

	return entityType === "compositeDevice" || !entity?.isGroup;
};

export const isValidDeviceDragPayload = payload =>
	!!(payload?.entityId || payload?.id) &&
	PLACEABLE_DEVICE_ENTITY_TYPES.includes(payload?.entityType || payload?.type);

export const createDeviceDragPayload = ({
	source,
	entityId,
	entityType,
	sourceGroupId = null,
	name = "",
	feedId = null,
	entityData = null,
	icon = null,
	deviceStateColor = null,
	deviceType = null
}) => ({
	source,
	entityId,
	entityType,
	id: entityId,
	type: entityType,
	sourceGroupId: sourceGroupId || null,
	name,
	feedId,
	entityData,
	icon,
	deviceStateColor,
	deviceType
});

export const setCurrentDeviceDragPayload = payload => {
	currentDeviceDragPayload = isValidDeviceDragPayload(payload) ? payload : null;
};

export const getCurrentDeviceDragPayload = () => currentDeviceDragPayload;

export const clearCurrentDeviceDragPayload = () => {
	currentDeviceDragPayload = null;
};

export const populateDeviceDragEvent = (event, payload) => {
	if (!event?.dataTransfer || !isValidDeviceDragPayload(payload)) return;

	const serializedPayload = JSON.stringify(payload);
	event.dataTransfer.effectAllowed = "copyMove";
	event.dataTransfer.setData(DEVICE_TREE_DND_MIME, serializedPayload);
	event.dataTransfer.setData("text/plain", serializedPayload);
};

export const getDeviceGroupDropDataset = groupNode =>
	groupNode?.isGroup && groupNode?.id !== "root"
		? {
				"data-device-group-drop-id": groupNode.id,
				"data-device-group-drop-name": groupNode.name || ""
			}
		: {};

export const getDeviceGroupDropTargetFromElement = element => {
	if (!element) return null;

	const resolvedElement = element.nodeType === Node.TEXT_NODE ? element.parentElement : element;
	const targetElement = resolvedElement?.closest?.("[data-device-group-drop-id]");
	if (!targetElement) return null;

	const targetGroupId = targetElement.getAttribute("data-device-group-drop-id");
	if (!targetGroupId || targetGroupId === "root") return null;

	return {
		targetGroupId,
		targetGroupName: targetElement.getAttribute("data-device-group-drop-name")
	};
};

export const getDeviceDragPayloadFromEvent = event => {
	const rawData = event?.dataTransfer?.getData(DEVICE_TREE_DND_MIME) || event?.dataTransfer?.getData("text/plain");

	if (rawData) {
		try {
			const payload = JSON.parse(rawData);
			return isValidDeviceDragPayload(payload) ? payload : null;
		} catch (error) {
			console.error("Unable to parse device drag payload", error);
		}
	}

	const payload = getCurrentDeviceDragPayload();
	return isValidDeviceDragPayload(payload) ? payload : null;
};
